import DateFieldFormValue from "../ReusableFormValues/DateFieldFormValue";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { screeningResultsAssessmentTypesArray } from "./constants";

interface Props {
  readonly: boolean;
}

const ScreeningResultsFormvalues = ({ readonly }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={screeningResultsAssessmentTypesArray}
        placeholder="Select an assessment"
        name="assessment"
        label="Assessment"
      />
      <DateFieldFormValue name="date" readonly={readonly} maxDate={new Date()} />
    </>
  );
};

export default ScreeningResultsFormvalues;
